export const MODALS = {
  TRANSACTION: 'transaction',
  ACCOUNT: 'account',
  WALLET_OPTIONS: 'walletOptions',
}
